// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search_result {\n  background: #f6f6ef;\n  min-height: 80vh; }\n\n.search_result:last-child {\n  padding-bottom: 10px; }\n", ""]);
// Exports
module.exports = exports;
